<template>
  <div>
    <div
      v-for="(item, index) in daysOfWeek"
      :key="index"
      class="d-inline-block ml-2"
    >
      <input
        :checked="isChecked(item)"
        :value="item"
        :id="transformDateCustom(item, 'ddd')"
        type="checkbox"
        class="form-check-input"
        @change="updateSelectedDays"
      />
      <label :for="transformDateCustom(item, 'ddd')" class="label-day">{{
        item
      }}</label>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import profileMixin from "@/mixins/profileMixin";

export default {
  name: "CheckboxWeek",
  mixins: [profileMixin],

  props: {
    date: {
      type: Array,
      required: true,
    },
    selectedDate: {
      type: Array,
    },
  },

  data() {
    return {
      weekDays: [],
      test: "",
    };
  },

  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },

    isChecked(item) {
      if (this.selectedDate && this.selectedDate.length > 0) {
        const matchedValues = this.selectedDate.filter(
          (date) => moment(date).format("ddd") === item
        );

        return matchedValues.length > 0;
      }

      return false;
    },

    updateSelectedDays() {
      this.selectedDays = this.daysOfWeek.filter((item) =>
        this.isChecked(item)
      );
      this.$emit("days", this.selectedDays);
    },
  },

  computed: {
    daysOfWeek() {
      return this.date.map((date) => moment(date).format("ddd"));
    },
  },

  mounted() {
    if (this.selectedDate && this.selectedDate.length > 0) {
      this.selectedDays = this.selectedDate.map((day) =>
        moment().day(day).format("ddd")
      );
    }
  },
};
</script>


<style scoped>
.form-check-input:checked {
  background-color: #670875;
  border-color: #670875;
}
.form-check-input {
  width: 18px;
  height: 18px;
}
.label-day {
  color: #603975;
  font-size: 14px;
  font-weight: 400;
}
.form-check-input:focus {
  border-color: #613975;
  outline: 0;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckboxWeek.vue